import React, { Component } from 'react';
import { DRNInputField, DRNTouchableWrapper } from '@traveloka/district-ui';

// Icons
import IcSystemEyeHide from '@traveloka/district-icon/IcSystemEyeHide';
import IcSystemEyeShow from '@traveloka/district-icon/IcSystemEyeShow';

export default class PasswordInput extends Component {
  state = {
    showPassword: false,
  };
  render() {
    const { showPassword } = this.state;

    return (
      <DRNInputField
        {...this.props}
        secureTextEntry={!showPassword}
        renderAccessory={() => (
          <DRNTouchableWrapper
            onPress={() => this.setState({ showPassword: !showPassword })}
          >
            {showPassword ? <IcSystemEyeShow /> : <IcSystemEyeHide />}
          </DRNTouchableWrapper>
        )}
      />
    );
  }
}
